import faqs from '@renter-hub/constants/FaqConstants';

export const pageFlows = {
  FrequencyPage: 'FrequencyPage',
  ManualSchedulingPage: 'ManualSchedulingPage',
  RecurringSchedulingPage: 'RecurringSchedulingPage',
  SelectPaymentMethodPage: 'SelectPaymentMethodPage',
  RecurringConfirmationPage: 'RecurringConfirmationPage',
  OneTimeConfirmationPage: 'OneTimeConfirmationPage',
  OverduePage: 'OverduePage',
  PaymentReportingPage: 'PaymentReportingPage',
};

export const getFaqs = (currentPage: string) => {
  switch (currentPage) {
    case pageFlows.FrequencyPage:
    default:
      return faqs.PAYMENT_SETTINGS_V2.FREQUENCY_PAGE;
    case pageFlows.ManualSchedulingPage:
      return faqs.PAYMENT_SETTINGS_V2.SCHEDULING_PAGE;
    case pageFlows.RecurringSchedulingPage:
      return faqs.PAYMENT_SETTINGS_V2.SCHEDULING_PAGE;
    case pageFlows.RecurringConfirmationPage:
      return faqs.PAYMENT_SETTINGS_V2.CONFIRMATION_PAGE;
    case pageFlows.OverduePage:
      return faqs.PAYMENT_SETTINGS_V2.OVERDUE_SCHEDULING_PAGE;
    case pageFlows.PaymentReportingPage:
      return faqs.PAYMENT_SETTINGS_V2.PAYMENT_REPORTING;
    case pageFlows.OneTimeConfirmationPage:
      return null;
    case pageFlows.SelectPaymentMethodPage:
      return null;
  }
};
